<template>
  <main id="main">
    <section class="section section__content" v-if="$page">
      <h1 class="title --main" v-if="$page.title">{{ $page.title }}</h1>
      <RawHtml :html="$page.description" v-if="$page.description" />
    </section>
    <Transition name="fade">
      <Loader v-if="!$page" />
    </Transition>
  </main>
</template>

<script>
import { RawHtml } from '@/components/global'
import { Loader } from '@/components/small'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Policies',
  mixins: [PageMetaMixin],
  beetPage: 'policies',
  components: {
    RawHtml,
    Loader,
  },
}
</script>
